import * as React from "react";
import { VStack } from "@chakra-ui/react";

const FullScreenSection = ({ children, isDarkBackground, ...boxProps }) => {
  return (
    <VStack
      backgroundColor={boxProps.backgroundColor}
      color={isDarkBackground ? "white" : "black"}
      minHeight="100vh"
      {...boxProps}
    >
      {children}
    </VStack>
  );
};

export default FullScreenSection;
